<template lang="pug">
  .round-shade
    .a-box-xs-1x1
      .a-box-content
        img-box(v-bind:media-obj="mediaObj")

</template>

<script>
  export default {
    name: "RoundShade",

    props: {
      mediaObj: {
        type: Object,
        required: true,
        default: () => {}
      }
    }
  };
</script>


<style scoped lang="stylus">
  .round-shade
    border-radius 50%
    overflow hidden

</style>
